import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as UiReducer from './ui-state.reducer';
import { UiState } from './ui-state.reducer';

export const getUiState = createFeatureSelector<UiReducer.UiState>('uiState');

export const getScreenType = createSelector(getUiState, UiReducer.getScreenType);

export const isMobile = createSelector(getScreenType, (screenType) => {
  return screenType === 'mobile';
});

export const isTablet = createSelector(getScreenType, (screenType) => {
  return screenType === 'tablet';
});

export const isDesktop = createSelector(getScreenType, (screenType) => {
  return screenType === 'desktop';
});

export const notMobile = createSelector(getScreenType, (screenType) => {
  return screenType !== 'mobile';
});

export const notDesktop = createSelector(getScreenType, (screenType) => {
  return screenType !== 'desktop';
});

export const leftColHidden = createSelector(getUiState, (state: UiState) => state.leftColHidden);

export const getUploadPolicy = createSelector(getUiState, (state: UiState) => state.uploadPolicy);
